module.exports = __webpack_public_path__ + "img/poster.e75a8692.png";